import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useMenuAccess } from "../contexts/MenuAccessContext";

const DebugPage = () => {
  const { user } = useAuth();
  const { menuAccess, loading, getCurrentUserAccess } = useMenuAccess();

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">Debug Information</h1>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">User Information</h2>
          <pre className="bg-gray-100 p-4 rounded overflow-auto">
            {JSON.stringify(user, null, 2)}
          </pre>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">
            Menu Access Loading State
          </h2>
          <p>Loading: {loading ? "Yes" : "No"}</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Menu Access Data</h2>
          <pre className="bg-gray-100 p-4 rounded overflow-auto">
            {JSON.stringify(menuAccess, null, 2)}
          </pre>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Access Check Results</h2>
          <div className="space-y-2">
            <p>
              getCurrentUserAccess("leads"):{" "}
              {String(getCurrentUserAccess("leads"))}
            </p>
            <p>
              getCurrentUserAccess("appointments"):{" "}
              {String(getCurrentUserAccess("appointments"))}
            </p>
            <p>
              getCurrentUserAccess("tasks"):{" "}
              {String(getCurrentUserAccess("tasks"))}
            </p>
            <p>
              getCurrentUserAccess("analytics"):{" "}
              {String(getCurrentUserAccess("analytics"))}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebugPage;
